import React, { useEffect, useState } from "react";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import { reqData } from "../../common/api";
import { useLocation } from "react-router-dom";
import Loader from "../../common/Loader";

const Sub_Blog = () => {
  const [data, setData] = useState();
  const [search,setSearch]=useState('');
  const [filteredData,setFilteredData]=useState(data?.blogs)
  const [loading, setLoading] = useState();
  const location = useLocation();
  const slug = location.pathname.replace("/sub_blogs", "");
  const subBlog = process.env.REACT_APP_SUB_BLOG + slug;
  function getData() {
    reqData(subBlog, setData, "", "", setLoading);
  }
  useEffect(() => {
    getData();
  }, []);
  useEffect(()=>{
    if(data){
      setFilteredData(data?.blogs)
    }
  },[data])

useEffect(()=>{
  const newData = filteredData?.filter((item)=>item.title_en.toLowerCase().includes(search.toLowerCase()));
  setFilteredData(newData)
},[search])
  const bg_color="#ffffff";
  return (
    <>
    {loading ? <Loader bgColor={bg_color} /> : 
      <div className="wrapper">
        <Header />
        <div
          className="modal fade popup sidemenuToggle"
          id="sidemenuToggle"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content bid-success-content">
              <button
                type="button"
                className="btn-custom-closer"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ri-close-fill"></i>
              </button>
              <div className="modal-body pa-8">
                <div className="row">
                  <div className="col-12 mb-5">
                    <nav className="side-nav w-100">
                      <ul>
                        <li>
                          <a href="index.html">
                            <i className="ri-home-4-line"></i> Home{" "}
                          </a>
                        </li>
                        <li>
                          <a href="blog.html">
                            <i className="ri-rss-line"></i> Blogs{" "}
                          </a>
                        </li>
                        <li>
                          <a href="top100.html">
                            <i className="ri-vip-crown-2-line"></i> TOP 100{" "}
                          </a>
                        </li>
                        <li>
                          <a href="resources.html">
                            <i className="ri-search-eye-line"></i> Resources{" "}
                          </a>
                        </li>
                        <li>
                          <a href="faq.html">
                            <i className="ri-database-2-line"></i> FAQ{" "}
                          </a>
                        </li>
                        <li>
                          <a href="trends.html">
                            <i className="ri-profile-line"></i> Trends{" "}
                          </a>
                        </li>
                        <li>
                          <a href="price.html">
                            <i className="ri-price-tag-3-line"></i> Price{" "}
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0);">
                            <i className="ri-user-line"></i> Register Your Brand{" "}
                          </a>
                        </li>
                        <li>
                          <a href="top500.html">
                            <i className="ri-global-fill"></i> Top 500{" "}
                          </a>
                        </li>
                        <li>
                          <a href="googlesearch.html">
                            <i className="ri-file-search-line"></i> Google Search{" "}
                          </a>
                        </li>
                        <li>
                          <a href="topnews.html">
                            <i className="ri-file-list-3-line"></i> Top News{" "}
                          </a>
                        </li>
                        <li>
                          <a href="topwiki.html">
                            <i className="ri-creative-commons-sa-line"></i> Top Wiki{" "}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div className="col-lg-4">
                    <div className="boxPanelBd">
                      <div className="footer-widget">
                        <h4>Follow Us</h4>
                      </div>
                      <div className="social">
                        <a className="icon-facebook" >
                          <i className="ri-facebook-line"></i>
                        </a>
                        <a className="icon-twitter" >
                          <i className="ri-twitter-line"></i>
                        </a>
                        <a className="icon-instagram" >
                          <i className="ri-instagram-line"></i>
                        </a>
                        <a className="icon-linkedin" >
                          <i className="ri-linkedin-line"></i>
                        </a>
                        <a className="icon-linkedin" >
                          <i className="ri-youtube-line"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="boxPanelBd">
                      <div className="footer-widget">
                        <h4>Contact Us</h4>
                      </div>
                      <a  className="btn btn-gradient btn-small">
                        <span>
                          <i className="ri-wallet-3-line"></i>Support{" "}
                        </span>
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="boxPanelBd">
                      <div className="footer-widget">
                        <h4>Mail Us</h4>
                      </div>
                      <form action="#">
                        <div className="subscribe-mail">
                          <input
                            type="text"
                            name="email"
                            id="subscribe-email"
                            placeholder="Email Address"
                          />
                          <button className="btn btn-small btn-gradient">
                            <span>
                              <i className="ri-send-plane-line"></i>
                            </span>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="innerHeader">
          <h2>Blog</h2>
          <span>Digital | Social | Online | Influencers</span>
        </section>
        <section className="pb-10 live-auction pt-8">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <section className="section-p BlogPageArea ">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-7">
                        {filteredData?.slice(0, 3).map((item, index) => {
                          return (
                            <div
                              className=" blog-img-card q-radius-10 position-relative q-p-margin-b-30"
                              key={index}
                            >
                              <img
                                src={data?.img_base_url + item.photo_file}
                                className="card-img-top"
                                alt="blog.webp"
                              />
                              <div className="blog-cata-n q-radius-5 position-absolute">
                                <p className="m-0 q-text-heading-color">{data?.category}</p>
                              </div>
                              <div className="card-body">
                                <div className="post-details">
                                  <div className="row">
                                    <div className="col-lg-5 col-md-5 pr-0">
                                      <p className="m-0 pt-1">
                                        <span>
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M8 0C6.41775 0 4.87103 0.469191 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842854 10.1217 0 8 0ZM10.984 10.1L10.339 10.906C10.2536 11.0128 10.1292 11.0814 9.99327 11.0966C9.85732 11.1118 9.7209 11.0724 9.614 10.987L7.453 9.387C7.302 9.26616 7.18011 9.11293 7.09633 8.93862C7.01255 8.76431 6.96903 8.57339 6.969 8.38V3.355C6.969 3.21815 7.02337 3.0869 7.12014 2.99013C7.2169 2.89336 7.34815 2.839 7.485 2.839H8.517C8.65386 2.839 8.7851 2.89336 8.88187 2.99013C8.97864 3.0869 9.033 3.21815 9.033 3.355V8L10.9 9.371C10.9537 9.41312 10.9985 9.46547 11.0319 9.52503C11.0652 9.58459 11.0864 9.65016 11.0942 9.71796C11.102 9.78577 11.0963 9.85444 11.0774 9.92002C11.0585 9.9856 11.0267 10.0468 10.984 10.1Z"
                                              fill="#707070"
                                            ></path>
                                          </svg>
                                        </span>
                                        October 25, 2021
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <h3 className="card-title q-p-margin-t-10 q-p-margin-b-10">
                                  {item.title_en}
                                </h3>
                                <p className="card-text q-p-margin-b-40">
                                  {item.details_en}
                                </p>
                                <a  className="btn quax-primary-btn">
                                  Continue{" "}
                                  <span>
                                    <svg
                                      width="20"
                                      height="10"
                                      viewBox="0 0 20 10"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M18.782 4.07599L14.9 0.21599C14.7605 0.0771495 14.5716 -0.000588814 14.3747 -0.000119962C14.1779 0.00034889 13.9893 0.0789889 13.8505 0.218493C13.7117 0.357997 13.6339 0.546942 13.6344 0.743761C13.6349 0.940581 13.7135 1.12915 13.853 1.26799L16.453 3.85898H0.742C0.545209 3.85898 0.356479 3.93716 0.217327 4.07631C0.0781748 4.21546 0 4.40419 0 4.60098C0 4.79778 0.0781748 4.98651 0.217327 5.12566C0.356479 5.26481 0.545209 5.34299 0.742 5.34299H16.46L13.86 7.93399C13.7205 8.07283 13.6419 8.2614 13.6414 8.45822C13.6409 8.65504 13.7187 8.84399 13.8575 8.98349C13.9963 9.123 14.1849 9.20162 14.3817 9.20209C14.5786 9.20256 14.7675 9.12482 14.907 8.98598L18.785 5.12699C18.8538 5.05779 18.9084 4.97571 18.9455 4.88544C18.9826 4.79517 19.0015 4.69846 19.0012 4.60086C19.001 4.50326 18.9815 4.40668 18.9438 4.31662C18.9062 4.22656 18.8512 4.14479 18.782 4.07599Z"
                                        fill="white"
                                      ></path>
                                    </svg>
                                  </span>
                                </a>
                              </div>
                            </div>
                          );
                        })}
                        <div className="pagination-box mx-auto">
                          <nav aria-label="">
                            <ul className="pagination">
                              <li className="page-item q-radius-5">
                                <a className="page-link" >
                                  <svg
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M1.218 5.12689L5.1 8.98689C5.2395 9.12573 5.42845 9.20347 5.62527 9.203C5.82209 9.20253 6.01066 9.12389 6.1495 8.98439C6.28834 8.84488 6.36608 8.65594 6.36561 8.45912C6.36514 8.2623 6.2865 8.07373 6.147 7.93489L3.547 5.3439L19.258 5.3439C19.4548 5.3439 19.6435 5.26572 19.7827 5.12657C19.9218 4.98742 20 4.79869 20 4.6019C20 4.40511 19.9218 4.21637 19.7827 4.07722C19.6435 3.93807 19.4548 3.85989 19.258 3.85989L3.54 3.85989L6.14 1.26889C6.2795 1.13005 6.35814 0.941477 6.35861 0.744658C6.35908 0.547838 6.28134 0.358892 6.1425 0.219389C6.00366 0.0798855 5.81509 0.00126076 5.61827 0.00079155C5.42145 0.000322342 5.2325 0.0780611 5.093 0.216902L1.215 4.0759C1.14617 4.14509 1.09164 4.22717 1.05454 4.31744C1.01744 4.40772 0.998482 4.50442 0.99876 4.60202C0.999039 4.69962 1.01854 4.7962 1.05616 4.88626C1.09378 4.97632 1.14877 5.05809 1.218 5.12689Z"
                                      fill="#ACACAC"
                                    ></path>
                                  </svg>
                                </a>
                              </li>
                              <li
                                className="page-item q-radius-5 active"
                                aria-current="page"
                              >
                                <a className="page-link" >
                                  1
                                </a>
                              </li>
                              <li className="page-item q-radius-5">
                                <a className="page-link" >
                                  2
                                </a>
                              </li>
                              <li className="page-item q-radius-5">
                                <a className="page-link" >
                                  3
                                </a>
                              </li>
                              <li className="page-item q-radius-5">
                                <a className="page-link" >
                                  ...
                                </a>
                              </li>
                              <li className="page-item q-radius-5">
                                <a className="page-link" >
                                  <svg
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M18.782 4.07599L14.9 0.21599C14.7605 0.0771495 14.5716 -0.000588814 14.3747 -0.000119962C14.1779 0.00034889 13.9893 0.0789889 13.8505 0.218493C13.7117 0.357997 13.6339 0.546942 13.6344 0.743761C13.6349 0.940581 13.7135 1.12915 13.853 1.26799L16.453 3.85898H0.742C0.545209 3.85898 0.356479 3.93716 0.217327 4.07631C0.0781748 4.21546 0 4.40419 0 4.60098C0 4.79778 0.0781748 4.98651 0.217327 5.12566C0.356479 5.26481 0.545209 5.34299 0.742 5.34299H16.46L13.86 7.93399C13.7205 8.07283 13.6419 8.2614 13.6414 8.45822C13.6409 8.65504 13.7187 8.84399 13.8575 8.98349C13.9963 9.123 14.1849 9.20162 14.3817 9.20209C14.5786 9.20256 14.7675 9.12482 14.907 8.98598L18.785 5.12699C18.8538 5.05779 18.9084 4.97571 18.9455 4.88544C18.9826 4.79517 19.0015 4.69846 19.0012 4.60086C19.001 4.50326 18.9815 4.40668 18.9438 4.31662C18.9062 4.22656 18.8512 4.14479 18.782 4.07599Z"
                                      fill="#2D4C9F"
                                    ></path>
                                  </svg>
                                </a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                      <div className="col-lg-5 mt-0 mt-lg-0">
                        <div className="sidebar float-end float-md-start float-sm-start">
                          <div className="input-group mb-3">
                            <input
                              type="search"
                              className="form-control"
                              placeholder="Type here"
                              aria-label="Type here"
                              aria-describedby="button-addon2"
                              value={search}
                              onChange={(e)=>setSearch(e.target.value)}
                            />
                            <button
                              className="btn quax-primary-btn"
                              type="submit"
                              id="button-addon2"
                            >
                              Search
                            </button>
                          </div>
                          <div className="resent-post sidebar-box q-p-margin-t-30 q-border q-radius-10">
                            <h5>Recent Posts</h5>
                            {data?.recent_posts?.map((item, index) => {
                              return (
                                <div
                                  className={`post-item post-item-border ${
                                    index === 0 ? "" : "q-p-margin-t-20"
                                  }`}
                                  key={index}
                                >
                                  <div className="row">
                                    <div className="col-sm-5">
                                      <img
                                        src={data?.img_base_url + item.photo_file}
                                        className="img-fluid"
                                        alt="Rectangle300.webp"
                                      />
                                    </div>
                                    <div className="col-sm-7 align-self-center">
                                      <p className="para-one q-text-heading-color">
                                        {item.title_en}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          <div className="sidebar-box q-p-margin-t-30 q-border q-radius-10">
                            <h5>Categories</h5>
                            <div className="sidebar-catagory">
                              {data?.categories
                                .slice(0, 6)
                                .map((item, index) => {
                                  return (
                                    <p
                                      className="para-one q-text-heading-color"
                                      key={index}
                                    >
                                      {item.title_en}
                                    </p>
                                  );
                                })}
                            </div>
                          </div>
                          {/* <div className="sidebar-box q-p-margin-t-30 q-border q-radius-10">
                                  <h5>Follow Us</h5>
                                  <div className="sidebar-social">
                                      <div className="row">
                                          <div className="col-4"><a ><svg width="50" height="50" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M87 0H3C1.34315 0 0 1.34315 0 3V87C0 88.6569 1.34315 90 3 90H87C88.6569 90 90 88.6569 90 87V3C90 1.34315 88.6569 0 87 0Z" fill="#3B5998"></path><path d="M51.01 46.625L51.732 41.92H47.22V38.866C47.1886 38.5146 47.2366 38.1606 47.3605 37.8303C47.4844 37.4999 47.681 37.2017 47.9358 36.9576C48.1905 36.7135 48.4969 36.5298 48.8322 36.4202C49.1676 36.3105 49.5233 36.2776 49.873 36.324H51.926V32.318C50.7207 32.1233 49.5028 32.017 48.282 32C44.564 32 42.133 34.254 42.133 38.333V41.92H38V46.625H42.133V58H47.22V46.625H51.01Z" fill="white"></path></svg></a></div>
                                          <div className="col-4"><a ><svg width="50" height="50" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M87 0H3C1.34315 0 0 1.34315 0 3V87C0 88.6569 1.34315 90 3 90H87C88.6569 90 90 88.6569 90 87V3C90 1.34315 88.6569 0 87 0Z" fill="#00ACED"></path><path d="M55.327 40.234C55.344 40.464 55.344 40.693 55.344 40.923C55.3526 42.9124 54.9657 44.8837 54.2057 46.7223C53.4458 48.5609 52.3281 50.2301 50.9174 51.6329C49.5067 53.0358 47.8313 54.1443 45.9886 54.894C44.1458 55.6436 42.1724 56.0196 40.183 56C37.2833 56.0071 34.4428 55.1802 32 53.618C32.4274 53.6649 32.8571 53.687 33.287 53.684C35.6827 53.6895 38.0112 52.8917 39.9 51.418C38.7915 51.3995 37.7163 51.0362 36.8238 50.3785C35.9313 49.7207 35.2659 48.8013 34.92 47.748C35.2528 47.8003 35.5891 47.8278 35.926 47.83C36.3983 47.8286 36.8687 47.7681 37.326 47.65C36.1224 47.4109 35.0388 46.7621 34.2597 45.814C33.4807 44.8659 33.0542 43.6771 33.053 42.45V42.384C33.7921 42.7941 34.6173 43.0247 35.462 43.057C34.3318 42.3114 33.5307 41.1607 33.2238 39.842C32.9168 38.5233 33.1273 37.1371 33.812 35.969C35.1543 37.6102 36.8255 38.9519 38.7181 39.9077C40.6106 40.8634 42.6825 41.412 44.8 41.518C44.7145 41.1189 44.6702 40.7121 44.668 40.304C44.6761 39.2383 45.0029 38.1995 45.6063 37.3211C46.2097 36.4427 47.0621 35.7649 48.0538 35.375C49.0456 34.985 50.1313 34.9007 51.1714 35.1329C52.2115 35.3652 53.1583 35.9032 53.89 36.678C55.0827 36.4496 56.2269 36.0165 57.272 35.398C56.873 36.6244 56.0398 37.6628 54.929 38.318C55.9879 38.1974 57.0229 37.9196 58 37.494C57.2695 38.5512 56.3658 39.4775 55.327 40.234Z" fill="white"></path></svg></a></div>
                                          <div className="col-4"><a ><svg width="50" height="50" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M87 0H3C1.34315 0 0 1.34315 0 3V87C0 88.6569 1.34315 90 3 90H87C88.6569 90 90 88.6569 90 87V3C90 1.34315 88.6569 0 87 0Z" fill="#DD4B39"></path><path d="M49.0479 43.8351C49.1606 44.4001 49.2172 44.9749 49.2169 45.5511C49.2169 51.4461 45.2639 55.6241 39.3169 55.6241C37.9541 55.6375 36.6021 55.3806 35.3392 54.8684C34.0763 54.3562 32.9274 53.5987 31.9589 52.6398C30.9905 51.6808 30.2218 50.5394 29.6971 49.2816C29.1725 48.0238 28.9023 46.6744 28.9023 45.3116C28.9023 43.9487 29.1725 42.5993 29.6971 41.3415C30.2218 40.0837 30.9905 38.9423 31.9589 37.9833C32.9274 37.0244 34.0763 36.2669 35.3392 35.7547C36.6021 35.2425 37.9541 34.9856 39.3169 34.9991C41.8834 34.9646 44.362 35.9334 46.2249 37.6991L43.4249 40.3861C42.3185 39.3355 40.8422 38.7641 39.3169 38.7961C37.609 38.826 35.9813 39.5254 34.7841 40.7438C33.5869 41.9621 32.916 43.6019 32.916 45.3101C32.916 47.0182 33.5869 48.658 34.7841 49.8763C35.9813 51.0947 37.609 51.7941 39.3169 51.8241C40.6653 51.9164 42.0014 51.5168 43.0776 50.6993C44.1539 49.8818 44.8972 48.7018 45.1699 47.3781H39.3129V43.8351H49.0489H49.0479ZM59.0059 44.1811V41.1881H55.9999V44.1811H53.0049V47.1891H55.9999V50.1821H59.0079V47.1891H61.9999V44.1811H59.0059Z" fill="white"></path></svg></a></div>
                                          <div className="col-4 q-p-margin-t-20"><a ><svg width="50" height="50" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M87 0H3C1.34315 0 0 1.34315 0 3V87C0 88.6569 1.34315 90 3 90H87C88.6569 90 90 88.6569 90 87V3C90 1.34315 88.6569 0 87 0Z" fill="#FF0084"></path><path d="M45 32C42.4288 32 39.9154 32.7624 37.7776 34.1909C35.6398 35.6194 33.9735 37.6497 32.9896 40.0251C32.0056 42.4006 31.7482 45.0144 32.2498 47.5362C32.7514 50.0579 33.9895 52.3743 35.8076 54.1924C37.6257 56.0105 39.9421 57.2486 42.4638 57.7502C44.9856 58.2518 47.5995 57.9944 49.9749 57.0104C52.3503 56.0265 54.3807 54.3603 55.8091 52.2224C57.2376 50.0846 58 47.5712 58 45C57.996 41.5534 56.6251 38.2491 54.188 35.812C51.7509 33.3749 48.4466 32.004 45 32ZM53.6 37.995C55.1987 39.9476 56.0809 42.3885 56.1 44.912C53.555 44.4071 50.9487 44.2868 48.368 44.555C48.068 43.819 47.782 43.171 47.392 42.374C49.8043 41.4788 51.9413 39.9698 53.592 37.996L53.6 37.995ZM52.366 36.711C50.8509 38.5785 48.8305 39.9709 46.546 40.722C45.3075 38.4677 43.9236 36.2965 42.403 34.222C44.1405 33.8025 45.9537 33.8098 47.6878 34.2432C49.4218 34.6767 51.0252 35.5234 52.361 36.711H52.366ZM40.279 34.968C41.767 37.0331 43.1427 39.1769 44.4 41.39C41.0484 42.2686 37.5998 42.7231 34.135 42.743C34.4901 41.061 35.2295 39.4839 36.2953 38.1351C37.3612 36.7863 38.7246 35.7023 40.279 34.968ZM33.9 45.017C33.9 44.903 33.9 44.79 33.906 44.678C37.764 44.6919 41.6046 44.1606 45.314 43.1C45.632 43.722 45.936 44.354 46.214 44.984C42.2633 46.2482 38.9026 48.8976 36.751 52.444C34.9123 50.4077 33.8962 47.7606 33.9 45.017ZM38.188 53.777C39.348 51.406 42.496 48.345 46.972 46.818C48.0265 49.5437 48.8197 52.3633 49.341 55.239C47.5202 56.0137 45.5251 56.2866 43.5631 56.0296C41.6011 55.7725 39.7438 54.9947 38.184 53.777H38.188ZM51.208 54.222C50.7156 51.5244 49.9927 48.874 49.047 46.3C51.3601 45.9605 53.7191 46.1225 55.964 46.775C55.7211 48.276 55.173 49.7113 54.3536 50.9921C53.5342 52.273 52.4609 53.3722 51.2 54.222H51.208Z" fill="white"></path></svg></a></div>
                                          <div className="col-4 q-p-margin-t-20"><a ><svg width="50" height="50" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M87 0H3C1.34315 0 0 1.34315 0 3V87C0 88.6569 1.34315 90 3 90H87C88.6569 90 90 88.6569 90 87V3C90 1.34315 88.6569 0 87 0Z" fill="#AAD450"></path><path d="M56.989 39.594C56.8863 41.8327 55.3223 44.8977 52.297 48.789C49.1703 52.8557 46.5247 54.889 44.36 54.889C43.02 54.889 41.8867 53.6517 40.96 51.177C39.149 44.543 38.379 40.656 36.885 40.656C36.2326 40.926 35.6237 41.2909 35.078 41.739L34 40.343C36.649 38.017 39.18 35.43 40.766 35.286C42.558 35.1113 43.66 36.335 44.072 38.957C45.545 48.275 46.197 49.682 48.877 45.457C49.6331 44.4229 50.1614 43.2402 50.427 41.987C50.673 39.631 48.589 39.787 47.177 40.396C48.3063 36.6947 50.466 34.8947 53.656 34.996C56.009 35.066 57.123 36.601 56.989 39.594Z" fill="white"></path></svg></a></div>
                                          <div className="col-4 q-p-margin-t-20"><a ><svg width="50" height="50" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M87 0H3C1.34315 0 0 1.34315 0 3V87C0 88.6569 1.34315 90 3 90H87C88.6569 90 90 88.6569 90 87V3C90 1.34315 88.6569 0 87 0Z" fill="#007BB5"></path><path d="M39.1476 56.999H34.3796V41.644H39.1476V56.999ZM36.7616 39.549C36.2127 39.5518 35.6753 39.3917 35.2174 39.089C34.7595 38.7862 34.4016 38.3545 34.1891 37.8484C33.9766 37.3423 33.9189 36.7845 34.0234 36.2456C34.1279 35.7068 34.3899 35.211 34.7763 34.821C35.1626 34.4311 35.6559 34.1644 36.1938 34.0549C36.7317 33.9453 37.2899 33.9977 37.798 34.2055C38.3061 34.4133 38.7412 34.7671 39.0481 35.2221C39.3551 35.6772 39.5203 36.2131 39.5226 36.762C39.5232 37.4968 39.2333 38.2021 38.7161 38.7241C38.199 39.2462 37.4964 39.5427 36.7616 39.549ZM56.9946 56.999H52.2366V49.524C52.2366 47.743 52.2006 45.458 49.7576 45.458C47.2786 45.458 46.8986 47.393 46.8986 49.396V56.996H42.1346V41.644H46.7076V43.739H46.7746C47.2319 42.956 47.8931 42.3118 48.6877 41.875C49.4823 41.4383 50.3805 41.2254 51.2866 41.259C56.1126 41.259 56.9996 44.437 56.9996 48.565V57L56.9946 56.999Z" fill="white"></path></svg></a></div>
                                      </div>
                                  </div>
                              </div> */}
                          <div className="sidebar-box q-p-margin-t-30 q-border q-radius-10">
                            <h5>Tags</h5>
                            <div className="sidebar-tags row">
                              {data?.popular_tags
                                ?.slice(0, 9)
                                .map((item, index) => {
                                  return (
                                    <div key={index} className="q-p-margin-b-20">
                                      <a
                                        className="q-section-gray q-text-paragraph-2 q-radius-3"
                                        
                                      >
                                        {item.tags}
                                      </a>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          {/* <div className="sidebar-box q-p-margin-t-30 q-border q-radius-10">
                                    <h5>About Author</h5>
                                    <div className="about-text">
                                        <p className="para-three">Pick a template, customize the content and design elements, and launc design your next fabulous email on your with our simple visual builder. Pick a template, customize the content and design elements.</p>
                                    </div>
                                </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>}
    </>
  );
};

export default Sub_Blog;
